import { useEffect } from "react";
import { UserRole } from "@repo/database";
import { useNavigate } from "@tanstack/react-router";

import { IdleTimer } from "~/components/miscellaneous/idle-timer";
import { Toaster } from "~/components/ui/sonner";
import AdminView from "~/components/view/admin";
import MerchantView from "~/components/view/merchant";
import { useUser } from "~/hooks/use-user";
import { api } from "~/lib/api";
import { useAuthStore } from "~/stores/use-auth-store";
import { EmployeeGroupProvider } from "./employee-group-provider";
import { EmployeeProvider } from "./employee-provider";
import { IntegrationProvider } from "./integration-provider";
import { NotificationProvider } from "./notification-provider";

export function AppProvider() {
  const { user } = useUser();

  const impersonateId = useAuthStore((state) => state.impersonateId);

  const navigate = useNavigate();

  const utils = api.useUtils();

  useEffect(() => {
    if (impersonateId) {
      void utils.invalidate();
    }
  }, [impersonateId, utils]);

  useEffect(() => {
    if (impersonateId) {
      void navigate({ to: "/" });
    } else {
      if (user.role === UserRole.admin) {
        void navigate({ to: "/admin" });
      }
    }
  }, [impersonateId, navigate, user.role]);

  return (
    <>
      <IntegrationProvider>
        <EmployeeGroupProvider>
          <EmployeeProvider>
            <Toaster
              toastOptions={{
                classNames: {
                  toast:
                    "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg group-[.toaster]:pointer-events-auto",
                },
              }}
              duration={1250}
              position="top-center"
              richColors={true}
              closeButton={true}
            />

            <IdleTimer />
            <NotificationProvider>
              {user.role === UserRole.admin && <AdminView />}
              {user.role !== UserRole.admin && <MerchantView />}
            </NotificationProvider>
          </EmployeeProvider>
        </EmployeeGroupProvider>
      </IntegrationProvider>
    </>
  );
}
